"use strict";(()=>{var jt=Object.defineProperty,fe=Object.defineProperties,ve=Object.getOwnPropertyDescriptor,be=Object.getOwnPropertyDescriptors;var Rt=Object.getOwnPropertySymbols;var xe=Object.prototype.hasOwnProperty,ye=Object.prototype.propertyIsEnumerable;var Bt=(s,t,e)=>t in s?jt(s,t,{enumerable:!0,configurable:!0,writable:!0,value:e}):s[t]=e,vt=(s,t)=>{for(var e in t||(t={}))xe.call(t,e)&&Bt(s,e,t[e]);if(Rt)for(var e of Rt(t))ye.call(t,e)&&Bt(s,e,t[e]);return s},bt=(s,t)=>fe(s,be(t));var n=(s,t,e,r)=>{for(var i=r>1?void 0:r?ve(t,e):t,o=s.length-1,a;o>=0;o--)(a=s[o])&&(i=(r?a(t,e,i):a(i))||i);return r&&i&&jt(t,e,i),i};var At=(s,t,e)=>new Promise((r,i)=>{var o=c=>{try{h(e.next(c))}catch(g){i(g)}},a=c=>{try{h(e.throw(c))}catch(g){i(g)}},h=c=>c.done?r(c.value):Promise.resolve(c.value).then(o,a);h((e=e.apply(s,t)).next())});var xt=globalThis,yt=xt.ShadowRoot&&(xt.ShadyCSS===void 0||xt.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,kt=Symbol(),Ht=new WeakMap,ot=class{constructor(t,e,r){if(this._$cssResult$=!0,r!==kt)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e}get styleSheet(){let t=this.o,e=this.t;if(yt&&t===void 0){let r=e!==void 0&&e.length===1;r&&(t=Ht.get(e)),t===void 0&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),r&&Ht.set(e,t))}return t}toString(){return this.cssText}},qt=s=>new ot(typeof s=="string"?s:s+"",void 0,kt),m=(s,...t)=>{let e=s.length===1?s[0]:t.reduce((r,i,o)=>r+(a=>{if(a._$cssResult$===!0)return a.cssText;if(typeof a=="number")return a;throw Error("Value passed to 'css' function must be a 'css' function result: "+a+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(i)+s[o+1],s[0]);return new ot(e,s,kt)},Tt=(s,t)=>{if(yt)s.adoptedStyleSheets=t.map(e=>e instanceof CSSStyleSheet?e:e.styleSheet);else for(let e of t){let r=document.createElement("style"),i=xt.litNonce;i!==void 0&&r.setAttribute("nonce",i),r.textContent=e.cssText,s.appendChild(r)}},$t=yt?s=>s:s=>s instanceof CSSStyleSheet?(t=>{let e="";for(let r of t.cssRules)e+=r.cssText;return qt(e)})(s):s;var{is:$e,defineProperty:we,getOwnPropertyDescriptor:_e,getOwnPropertyNames:Ee,getOwnPropertySymbols:Ae,getPrototypeOf:ke}=Object,B=globalThis,Vt=B.trustedTypes,Te=Vt?Vt.emptyScript:"",Pt=B.reactiveElementPolyfillSupport,nt=(s,t)=>s,at={toAttribute(s,t){switch(t){case Boolean:s=s?Te:null;break;case Object:case Array:s=s==null?s:JSON.stringify(s)}return s},fromAttribute(s,t){let e=s;switch(t){case Boolean:e=s!==null;break;case Number:e=s===null?null:Number(s);break;case Object:case Array:try{e=JSON.parse(s)}catch(r){e=null}}return e}},wt=(s,t)=>!$e(s,t),It={attribute:!0,type:String,converter:at,reflect:!1,hasChanged:wt},Dt,Ft;(Dt=Symbol.metadata)!=null||(Symbol.metadata=Symbol("metadata")),(Ft=B.litPropertyMetadata)!=null||(B.litPropertyMetadata=new WeakMap);var M=class extends HTMLElement{static addInitializer(t){var e;this._$Ei(),((e=this.l)!=null?e:this.l=[]).push(t)}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,e=It){if(e.state&&(e.attribute=!1),this._$Ei(),this.elementProperties.set(t,e),!e.noAccessor){let r=Symbol(),i=this.getPropertyDescriptor(t,r,e);i!==void 0&&we(this.prototype,t,i)}}static getPropertyDescriptor(t,e,r){var a;let{get:i,set:o}=(a=_e(this.prototype,t))!=null?a:{get(){return this[e]},set(h){this[e]=h}};return{get(){return i==null?void 0:i.call(this)},set(h){let c=i==null?void 0:i.call(this);o.call(this,h),this.requestUpdate(t,c,r)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){var e;return(e=this.elementProperties.get(t))!=null?e:It}static _$Ei(){if(this.hasOwnProperty(nt("elementProperties")))return;let t=ke(this);t.finalize(),t.l!==void 0&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties)}static finalize(){if(this.hasOwnProperty(nt("finalized")))return;if(this.finalized=!0,this._$Ei(),this.hasOwnProperty(nt("properties"))){let e=this.properties,r=[...Ee(e),...Ae(e)];for(let i of r)this.createProperty(i,e[i])}let t=this[Symbol.metadata];if(t!==null){let e=litPropertyMetadata.get(t);if(e!==void 0)for(let[r,i]of e)this.elementProperties.set(r,i)}this._$Eh=new Map;for(let[e,r]of this.elementProperties){let i=this._$Eu(e,r);i!==void 0&&this._$Eh.set(i,e)}this.elementStyles=this.finalizeStyles(this.styles)}static finalizeStyles(t){let e=[];if(Array.isArray(t)){let r=new Set(t.flat(1/0).reverse());for(let i of r)e.unshift($t(i))}else t!==void 0&&e.push($t(t));return e}static _$Eu(t,e){let r=e.attribute;return r===!1?void 0:typeof r=="string"?r:typeof t=="string"?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Em=null,this._$Ev()}_$Ev(){var t;this._$ES=new Promise(e=>this.enableUpdating=e),this._$AL=new Map,this._$E_(),this.requestUpdate(),(t=this.constructor.l)==null||t.forEach(e=>e(this))}addController(t){var e,r;((e=this._$EO)!=null?e:this._$EO=new Set).add(t),this.renderRoot!==void 0&&this.isConnected&&((r=t.hostConnected)==null||r.call(t))}removeController(t){var e;(e=this._$EO)==null||e.delete(t)}_$E_(){let t=new Map,e=this.constructor.elementProperties;for(let r of e.keys())this.hasOwnProperty(r)&&(t.set(r,this[r]),delete this[r]);t.size>0&&(this._$Ep=t)}createRenderRoot(){var e;let t=(e=this.shadowRoot)!=null?e:this.attachShadow(this.constructor.shadowRootOptions);return Tt(t,this.constructor.elementStyles),t}connectedCallback(){var t,e;(t=this.renderRoot)!=null||(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),(e=this._$EO)==null||e.forEach(r=>{var i;return(i=r.hostConnected)==null?void 0:i.call(r)})}enableUpdating(t){}disconnectedCallback(){var t;(t=this._$EO)==null||t.forEach(e=>{var r;return(r=e.hostDisconnected)==null?void 0:r.call(e)})}attributeChangedCallback(t,e,r){this._$AK(t,r)}_$EC(t,e){var o;let r=this.constructor.elementProperties.get(t),i=this.constructor._$Eu(t,r);if(i!==void 0&&r.reflect===!0){let a=(((o=r.converter)==null?void 0:o.toAttribute)!==void 0?r.converter:at).toAttribute(e,r.type);this._$Em=t,a==null?this.removeAttribute(i):this.setAttribute(i,a),this._$Em=null}}_$AK(t,e){var o;let r=this.constructor,i=r._$Eh.get(t);if(i!==void 0&&this._$Em!==i){let a=r.getPropertyOptions(i),h=typeof a.converter=="function"?{fromAttribute:a.converter}:((o=a.converter)==null?void 0:o.fromAttribute)!==void 0?a.converter:at;this._$Em=i,this[i]=h.fromAttribute(e,a.type),this._$Em=null}}requestUpdate(t,e,r){var i;if(t!==void 0){if(r!=null||(r=this.constructor.getPropertyOptions(t)),!((i=r.hasChanged)!=null?i:wt)(this[t],e))return;this.P(t,e,r)}this.isUpdatePending===!1&&(this._$ES=this._$ET())}P(t,e,r){var i;this._$AL.has(t)||this._$AL.set(t,e),r.reflect===!0&&this._$Em!==t&&((i=this._$Ej)!=null?i:this._$Ej=new Set).add(t)}_$ET(){return At(this,null,function*(){this.isUpdatePending=!0;try{yield this._$ES}catch(e){Promise.reject(e)}let t=this.scheduleUpdate();return t!=null&&(yield t),!this.isUpdatePending})}scheduleUpdate(){return this.performUpdate()}performUpdate(){var r,i;if(!this.isUpdatePending)return;if(!this.hasUpdated){if((r=this.renderRoot)!=null||(this.renderRoot=this.createRenderRoot()),this._$Ep){for(let[a,h]of this._$Ep)this[a]=h;this._$Ep=void 0}let o=this.constructor.elementProperties;if(o.size>0)for(let[a,h]of o)h.wrapped!==!0||this._$AL.has(a)||this[a]===void 0||this.P(a,this[a],h)}let t=!1,e=this._$AL;try{t=this.shouldUpdate(e),t?(this.willUpdate(e),(i=this._$EO)==null||i.forEach(o=>{var a;return(a=o.hostUpdate)==null?void 0:a.call(o)}),this.update(e)):this._$EU()}catch(o){throw t=!1,this._$EU(),o}t&&this._$AE(e)}willUpdate(t){}_$AE(t){var e;(e=this._$EO)==null||e.forEach(r=>{var i;return(i=r.hostUpdated)==null?void 0:i.call(r)}),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$EU(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return!0}update(t){this._$Ej&&(this._$Ej=this._$Ej.forEach(e=>this._$EC(e,this[e]))),this._$EU()}updated(t){}firstUpdated(t){}},Gt;M.elementStyles=[],M.shadowRootOptions={mode:"open"},M[nt("elementProperties")]=new Map,M[nt("finalized")]=new Map,Pt==null||Pt({ReactiveElement:M}),((Gt=B.reactiveElementVersions)!=null?Gt:B.reactiveElementVersions=[]).push("2.0.4");var ct=globalThis,_t=ct.trustedTypes,Kt=_t?_t.createPolicy("lit-html",{createHTML:s=>s}):void 0,te="$lit$",j=`lit$${Math.random().toFixed(9).slice(2)}$`,ee="?"+j,Pe=`<${ee}>`,K=document,pt=()=>K.createComment(""),dt=s=>s===null||typeof s!="object"&&typeof s!="function",re=Array.isArray,Ce=s=>re(s)||typeof(s==null?void 0:s[Symbol.iterator])=="function",Ct=`[ 	
\f\r]`,lt=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,Wt=/-->/g,Jt=/>/g,F=RegExp(`>|${Ct}(?:([^\\s"'>=/]+)(${Ct}*=${Ct}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`,"g"),Xt=/'/g,Zt=/"/g,ie=/^(?:script|style|textarea|title)$/i,se=s=>(t,...e)=>({_$litType$:s,strings:t,values:e}),d=se(1),Ze=se(2),y=Symbol.for("lit-noChange"),b=Symbol.for("lit-nothing"),Yt=new WeakMap,G=K.createTreeWalker(K,129);function oe(s,t){if(!Array.isArray(s)||!s.hasOwnProperty("raw"))throw Error("invalid template strings array");return Kt!==void 0?Kt.createHTML(t):t}var Ne=(s,t)=>{let e=s.length-1,r=[],i,o=t===2?"<svg>":"",a=lt;for(let h=0;h<e;h++){let c=s[h],g,v,f=-1,N=0;for(;N<c.length&&(a.lastIndex=N,v=a.exec(c),v!==null);)N=a.lastIndex,a===lt?v[1]==="!--"?a=Wt:v[1]!==void 0?a=Jt:v[2]!==void 0?(ie.test(v[2])&&(i=RegExp("</"+v[2],"g")),a=F):v[3]!==void 0&&(a=F):a===F?v[0]===">"?(a=i!=null?i:lt,f=-1):v[1]===void 0?f=-2:(f=a.lastIndex-v[2].length,g=v[1],a=v[3]===void 0?F:v[3]==='"'?Zt:Xt):a===Zt||a===Xt?a=F:a===Wt||a===Jt?a=lt:(a=F,i=void 0);let R=a===F&&s[h+1].startsWith("/>")?" ":"";o+=a===lt?c+Pe:f>=0?(r.push(g),c.slice(0,f)+te+c.slice(f)+j+R):c+j+(f===-2?h:R)}return[oe(s,o+(s[e]||"<?>")+(t===2?"</svg>":"")),r]},ht=class s{constructor({strings:t,_$litType$:e},r){let i;this.parts=[];let o=0,a=0,h=t.length-1,c=this.parts,[g,v]=Ne(t,e);if(this.el=s.createElement(g,r),G.currentNode=this.el.content,e===2){let f=this.el.content.firstChild;f.replaceWith(...f.childNodes)}for(;(i=G.nextNode())!==null&&c.length<h;){if(i.nodeType===1){if(i.hasAttributes())for(let f of i.getAttributeNames())if(f.endsWith(te)){let N=v[a++],R=i.getAttribute(f).split(j),ft=/([.?@])?(.*)/.exec(N);c.push({type:1,index:o,name:ft[2],strings:R,ctor:ft[1]==="."?St:ft[1]==="?"?Lt:ft[1]==="@"?Ut:tt}),i.removeAttribute(f)}else f.startsWith(j)&&(c.push({type:6,index:o}),i.removeAttribute(f));if(ie.test(i.tagName)){let f=i.textContent.split(j),N=f.length-1;if(N>0){i.textContent=_t?_t.emptyScript:"";for(let R=0;R<N;R++)i.append(f[R],pt()),G.nextNode(),c.push({type:2,index:++o});i.append(f[N],pt())}}}else if(i.nodeType===8)if(i.data===ee)c.push({type:2,index:o});else{let f=-1;for(;(f=i.data.indexOf(j,f+1))!==-1;)c.push({type:7,index:o}),f+=j.length-1}o++}}static createElement(t,e){let r=K.createElement("template");return r.innerHTML=t,r}};function Q(s,t,e=s,r){var a,h,c;if(t===y)return t;let i=r!==void 0?(a=e._$Co)==null?void 0:a[r]:e._$Cl,o=dt(t)?void 0:t._$litDirective$;return(i==null?void 0:i.constructor)!==o&&((h=i==null?void 0:i._$AO)==null||h.call(i,!1),o===void 0?i=void 0:(i=new o(s),i._$AT(s,e,r)),r!==void 0?((c=e._$Co)!=null?c:e._$Co=[])[r]=i:e._$Cl=i),i!==void 0&&(t=Q(s,i._$AS(s,t.values),i,r)),t}var Mt=class{constructor(t,e){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=e}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){var g;let{el:{content:e},parts:r}=this._$AD,i=((g=t==null?void 0:t.creationScope)!=null?g:K).importNode(e,!0);G.currentNode=i;let o=G.nextNode(),a=0,h=0,c=r[0];for(;c!==void 0;){if(a===c.index){let v;c.type===2?v=new mt(o,o.nextSibling,this,t):c.type===1?v=new c.ctor(o,c.name,c.strings,this,t):c.type===6&&(v=new Ot(o,this,t)),this._$AV.push(v),c=r[++h]}a!==(c==null?void 0:c.index)&&(o=G.nextNode(),a++)}return G.currentNode=K,i}p(t){let e=0;for(let r of this._$AV)r!==void 0&&(r.strings!==void 0?(r._$AI(t,r,e),e+=r.strings.length-2):r._$AI(t[e])),e++}},mt=class s{get _$AU(){var t,e;return(e=(t=this._$AM)==null?void 0:t._$AU)!=null?e:this._$Cv}constructor(t,e,r,i){var o;this.type=2,this._$AH=b,this._$AN=void 0,this._$AA=t,this._$AB=e,this._$AM=r,this.options=i,this._$Cv=(o=i==null?void 0:i.isConnected)!=null?o:!0}get parentNode(){let t=this._$AA.parentNode,e=this._$AM;return e!==void 0&&(t==null?void 0:t.nodeType)===11&&(t=e.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,e=this){t=Q(this,t,e),dt(t)?t===b||t==null||t===""?(this._$AH!==b&&this._$AR(),this._$AH=b):t!==this._$AH&&t!==y&&this._(t):t._$litType$!==void 0?this.$(t):t.nodeType!==void 0?this.T(t):Ce(t)?this.k(t):this._(t)}S(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.S(t))}_(t){this._$AH!==b&&dt(this._$AH)?this._$AA.nextSibling.data=t:this.T(K.createTextNode(t)),this._$AH=t}$(t){var o;let{values:e,_$litType$:r}=t,i=typeof r=="number"?this._$AC(t):(r.el===void 0&&(r.el=ht.createElement(oe(r.h,r.h[0]),this.options)),r);if(((o=this._$AH)==null?void 0:o._$AD)===i)this._$AH.p(e);else{let a=new Mt(i,this),h=a.u(this.options);a.p(e),this.T(h),this._$AH=a}}_$AC(t){let e=Yt.get(t.strings);return e===void 0&&Yt.set(t.strings,e=new ht(t)),e}k(t){re(this._$AH)||(this._$AH=[],this._$AR());let e=this._$AH,r,i=0;for(let o of t)i===e.length?e.push(r=new s(this.S(pt()),this.S(pt()),this,this.options)):r=e[i],r._$AI(o),i++;i<e.length&&(this._$AR(r&&r._$AB.nextSibling,i),e.length=i)}_$AR(t=this._$AA.nextSibling,e){var r;for((r=this._$AP)==null?void 0:r.call(this,!1,!0,e);t&&t!==this._$AB;){let i=t.nextSibling;t.remove(),t=i}}setConnected(t){var e;this._$AM===void 0&&(this._$Cv=t,(e=this._$AP)==null||e.call(this,t))}},tt=class{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,e,r,i,o){this.type=1,this._$AH=b,this._$AN=void 0,this.element=t,this.name=e,this._$AM=i,this.options=o,r.length>2||r[0]!==""||r[1]!==""?(this._$AH=Array(r.length-1).fill(new String),this.strings=r):this._$AH=b}_$AI(t,e=this,r,i){let o=this.strings,a=!1;if(o===void 0)t=Q(this,t,e,0),a=!dt(t)||t!==this._$AH&&t!==y,a&&(this._$AH=t);else{let h=t,c,g;for(t=o[0],c=0;c<o.length-1;c++)g=Q(this,h[r+c],e,c),g===y&&(g=this._$AH[c]),a||(a=!dt(g)||g!==this._$AH[c]),g===b?t=b:t!==b&&(t+=(g!=null?g:"")+o[c+1]),this._$AH[c]=g}a&&!i&&this.j(t)}j(t){t===b?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t!=null?t:"")}},St=class extends tt{constructor(){super(...arguments),this.type=3}j(t){this.element[this.name]=t===b?void 0:t}},Lt=class extends tt{constructor(){super(...arguments),this.type=4}j(t){this.element.toggleAttribute(this.name,!!t&&t!==b)}},Ut=class extends tt{constructor(t,e,r,i,o){super(t,e,r,i,o),this.type=5}_$AI(t,e=this){var a;if((t=(a=Q(this,t,e,0))!=null?a:b)===y)return;let r=this._$AH,i=t===b&&r!==b||t.capture!==r.capture||t.once!==r.once||t.passive!==r.passive,o=t!==b&&(r===b||i);i&&this.element.removeEventListener(this.name,this,r),o&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){var e,r;typeof this._$AH=="function"?this._$AH.call((r=(e=this.options)==null?void 0:e.host)!=null?r:this.element,t):this._$AH.handleEvent(t)}},Ot=class{constructor(t,e,r){this.element=t,this.type=6,this._$AN=void 0,this._$AM=e,this.options=r}get _$AU(){return this._$AM._$AU}_$AI(t){Q(this,t)}};var Nt=ct.litHtmlPolyfillSupport,Qt;Nt==null||Nt(ht,mt),((Qt=ct.litHtmlVersions)!=null?Qt:ct.litHtmlVersions=[]).push("3.1.3");var ne=(s,t,e)=>{var o,a;let r=(o=e==null?void 0:e.renderBefore)!=null?o:t,i=r._$litPart$;if(i===void 0){let h=(a=e==null?void 0:e.renderBefore)!=null?a:null;r._$litPart$=i=new mt(t.insertBefore(pt(),h),h,void 0,e!=null?e:{})}return i._$AI(s),i};var T=class extends M{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0}createRenderRoot(){var e,r;let t=super.createRenderRoot();return(r=(e=this.renderOptions).renderBefore)!=null||(e.renderBefore=t.firstChild),t}update(t){let e=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=ne(e,this.renderRoot,this.renderOptions)}connectedCallback(){var t;super.connectedCallback(),(t=this._$Do)==null||t.setConnected(!0)}disconnectedCallback(){var t;super.disconnectedCallback(),(t=this._$Do)==null||t.setConnected(!1)}render(){return y}},ae;T._$litElement$=!0,T.finalized=!0,(ae=globalThis.litElementHydrateSupport)==null||ae.call(globalThis,{LitElement:T});var zt=globalThis.litElementPolyfillSupport;zt==null||zt({LitElement:T});var le;((le=globalThis.litElementVersions)!=null?le:globalThis.litElementVersions=[]).push("4.0.5");var Me=m`
  /* reset css */
  /*! destyle.css v4.0.1 | MIT License | https://github.com/nicolas-cusan/destyle.min.css */
  *,
  ::before,
  ::after {
    box-sizing: border-box;
    border-style: solid;
    border-width: 0;
    min-width: 0;
  }
  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }
  body {
    margin: 0;
  }
  main {
    display: block;
  }
  p,
  table,
  blockquote,
  address,
  pre,
  iframe,
  form,
  figure,
  dl {
    margin: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
    margin: 0;
  }
  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  dt {
    font-weight: 700;
  }
  dd {
    margin-left: 0;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    border-top-width: 1px;
    margin: 0;
    clear: both;
    color: inherit;
  }
  pre {
    font-family: monospace, monospace;
    font-size: inherit;
  }
  address {
    font-style: inherit;
  }
  a {
    background-color: transparent;
    text-decoration: none;
    color: inherit;
  }
  abbr[title] {
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: inherit;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  svg,
  img,
  embed,
  object,
  iframe {
    vertical-align: bottom;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    -webkit-appearance: none;
    appearance: none;
    vertical-align: middle;
    color: inherit;
    font: inherit;
    background: transparent;
    padding: 0;
    margin: 0;
    border-radius: 0;
    text-align: inherit;
    text-transform: inherit;
  }
  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    cursor: pointer;
  }
  button:disabled,
  [type='button']:disabled,
  [type='reset']:disabled,
  [type='submit']:disabled {
    cursor: default;
  }
  :-moz-focusring {
    outline: auto;
  }
  select:disabled {
    opacity: inherit;
  }
  option {
    padding: 0;
  }
  fieldset {
    margin: 0;
    padding: 0;
    min-width: 0;
  }
  legend {
    padding: 0;
  }
  progress {
    vertical-align: baseline;
  }
  textarea {
    overflow: auto;
  }
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  [type='search'] {
    outline-offset: -2px;
  }
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  [type='number'] {
    -moz-appearance: textfield;
  }
  label[for] {
    cursor: pointer;
  }
  details {
    display: block;
  }
  summary {
    display: list-item;
  }
  [contenteditable]:focus {
    outline: auto;
  }
  table {
    border-color: inherit;
    border-collapse: collapse;
  }
  caption {
    text-align: left;
  }
  td,
  th {
    vertical-align: top;
    padding: 0;
  }
  th {
    text-align: left;
    font-weight: 700;
  }

  summary {
    list-style: none;
  }
  summary::-webkit-details-marker {
    display: none;
  }
`,Se=m`
  * {
    font-family: var(--font-FOT-TsukuAOldMin-Pr6);
  }
  @media (min-width: 768px) {
    .md-object-fit {
      object-fit: contain;
    }
  }

  .scroll-none {
    -ms-overflow-style: none;
    /*スクロールバー非表示（Firefox）*/
    scrollbar-width: none;
  }
  .scroll-none::-webkit-scrollbar {
    /*スクロールバー非表示（Chrome・Safari）*/
    display: none;
  }
`,p=class extends T{static register(){customElements.get(this.tagName)||customElements.define(this.tagName,this)}};p.styles=[Me,Se];var u=s=>(t,e)=>{e!==void 0?e.addInitializer(()=>{customElements.define(s,t)}):customElements.define(s,t)};var Le={attribute:!0,type:String,converter:at,reflect:!1,hasChanged:wt},Ue=(s=Le,t,e)=>{let{kind:r,metadata:i}=e,o=globalThis.litPropertyMetadata.get(i);if(o===void 0&&globalThis.litPropertyMetadata.set(i,o=new Map),o.set(e.name,s),r==="accessor"){let{name:a}=e;return{set(h){let c=t.get.call(this);t.set.call(this,h),this.requestUpdate(a,c,s)},init(h){return h!==void 0&&this.P(a,void 0,s),h}}}if(r==="setter"){let{name:a}=e;return function(h){let c=this[a];t.call(this,h),this.requestUpdate(a,c,s)}}throw Error("Unsupported decorator location: "+r)};function l(s){return(t,e)=>typeof e=="object"?Ue(s,t,e):((r,i,o)=>{let a=i.hasOwnProperty(o);return i.constructor.createProperty(o,a?bt(vt({},r),{wrapped:!0}):r),a?Object.getOwnPropertyDescriptor(i,o):void 0})(s,t,e)}function ut(s){return l(bt(vt({},s),{state:!0,attribute:!1}))}var W=(s,t,e)=>(e.configurable=!0,e.enumerable=!0,Reflect.decorate&&typeof t!="object"&&Object.defineProperty(s,t,e),e);function S(s,t){return(e,r,i)=>{let o=a=>{var h,c;return(c=(h=a.renderRoot)==null?void 0:h.querySelector(s))!=null?c:null};if(t){let{get:a,set:h}=typeof r=="object"?e:i!=null?i:(()=>{let c=Symbol();return{get(){return this[c]},set(g){this[c]=g}}})();return W(e,r,{get(){let c=a.call(this);return c===void 0&&(c=o(this),(c!==null||this.hasUpdated)&&h.call(this,c)),c}})}return W(e,r,{get(){return o(this)}})}}var et={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},rt=s=>(...t)=>({_$litDirective$:s,values:t}),H=class{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,r){this._$Ct=t,this._$AM=e,this._$Ci=r}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}};var _=rt(class extends H{constructor(s){var t;if(super(s),s.type!==et.ATTRIBUTE||s.name!=="class"||((t=s.strings)==null?void 0:t.length)>2)throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.")}render(s){return" "+Object.keys(s).filter(t=>s[t]).join(" ")+" "}update(s,[t]){var r,i;if(this.st===void 0){this.st=new Set,s.strings!==void 0&&(this.nt=new Set(s.strings.join(" ").split(/\s/).filter(o=>o!=="")));for(let o in t)t[o]&&!((r=this.nt)!=null&&r.has(o))&&this.st.add(o);return this.render(t)}let e=s.element.classList;for(let o of this.st)o in t||(e.remove(o),this.st.delete(o));for(let o in t){let a=!!t[o];a===this.st.has(o)||(i=this.nt)!=null&&i.has(o)||(a?(e.add(o),this.st.add(o)):(e.remove(o),this.st.delete(o)))}return y}});var ce="important",Oe=" !"+ce,Et=rt(class extends H{constructor(s){var t;if(super(s),s.type!==et.ATTRIBUTE||s.name!=="style"||((t=s.strings)==null?void 0:t.length)>2)throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.")}render(s){return Object.keys(s).reduce((t,e)=>{let r=s[e];return r==null?t:t+`${e=e.includes("-")?e:e.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g,"-$&").toLowerCase()}:${r};`},"")}update(s,[t]){let{style:e}=s.element;if(this.ft===void 0)return this.ft=new Set(Object.keys(t)),this.render(t);for(let r of this.ft)t[r]==null&&(this.ft.delete(r),r.includes("-")?e.removeProperty(r):e[r]=null);for(let r in t){let i=t[r];if(i!=null){this.ft.add(r);let o=typeof i=="string"&&i.endsWith(Oe);r.includes("-")||o?e.setProperty(r,o?i.slice(0,-11):i,o?ce:""):e[r]=i}}return y}});var P=class extends p{constructor(){super(...arguments);this.kind="contained";this.color="";this.loading=!1;this.disabled=!1}colorVar(){return this.color||{contained:"var(--color-white)",outlined:"var(--color-base)",transparent:"var(--color-white)"}[this.kind]}render(){let e=Et({"--text-color":this.colorVar()}),r=_({[this.kind]:!0,container:!0,disabled:this.disabled});return d`<div class=${r} style=${e}>
      <slot></slot>
      <div class="arrow">
        <right-arrow stroke=${this.colorVar()}></right-arrow>
      </div>
    </div>`}};P.tagName="main-button",P.styles=[p.styles,m`
      .container {
        width: 100%;
        padding: var(--spacing-6_5) 0;
        text-align: center;
        border-radius: var(--rounded-0_5);
        position: relative;
        font-weight: var(--font-normal);
        transition: background-color 0.1s linear;
      }
      .container:hover {
        background-color: var(--color-accent);
      }
      .container:hover {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      }
      .container:active {
        box-shadow: unset;
        opacity: 0.6;
      }
      .disabled {
        background-color: var(--color-disabled) !important;
        cursor: not-allowed;
      }
      .contained {
        background-color: var(--color-base);
      }
      .outlined {
        border: 1px solid var(--color-blue-gray);
      }
      .transparent {
        background-color: rgba(255, 255, 255, 0.3);
        border: 1px solid var(--color-white);
      }
      * {
        color: var(--text-color) !important;
      }

      .arrow {
        position: absolute;
        right: 32px;
        display: inline-block;
        width: 20px;
      }
    `],n([l()],P.prototype,"kind",2),n([l()],P.prototype,"color",2),n([l({type:Boolean})],P.prototype,"loading",2),n([l({type:Boolean})],P.prototype,"disabled",2),P=n([u("main-button")],P);var J=class extends p{constructor(){super(...arguments);this.link=""}render(){return d`
      <a href=${this.link}>
        <div class="container">
          <slot></slot>
        </div>
      </a>
    `}};J.tagName="pink-button",J.styles=[p.styles,m`
      .container {
        padding: var(--spacing-5);
        background-image: var(--bg-gradient-radial);
        color: var(--color-white);
        text-align: center;
        border-radius: var(--rounded-2_5);
        font-family: var(--font-hiragino-sans);
        size: var(--text-md);
        font-weight: var(--font-semibold);
      }
    `],n([l()],J.prototype,"link",2),J=n([u("pink-button")],J);var E=class extends p{constructor(){super(...arguments);this.link="";this.imgSrc="";this.name="";this.blackEffect=!1;this.targetBlank=!1}render(){let e=_({container:!0,"bg-black-effect":this.blackEffect,"bg-white-effect":!this.blackEffect}),r=this.targetBlank?"_blank":"_self",i=this.targetBlank?"noopener noreferrer":"";return d`<a href=${this.link} target=${r} rel=${i}>
      <div class=${e}>
        <div class="content">
          <slot></slot>
        </div>
        <div class="corner"></div>
      </div>
    </a>`}};E.tagName="sns-button",E.styles=[p.styles,m`
      .container {
        border-radius: var(--rounded-0_5);
        border: 1px solid var(--color-white);
        position: relative;
      }
      .container:hover {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
      }
      .container:active {
        box-shadow: unset;
        opacity: 0.6;
      }
      .bg-black-effect {
        background-color: rgba(0, 0, 0, 0.05);
      }
      .bg-white-effect {
        background-color: rgba(255, 255, 255, 0.2);
      }
      .corner {
        width: 10px;
        height: 10px;
        border-bottom: 1px solid var(--color-white);
        border-right: 1px solid var(--color-white);
        position: absolute;
        right: 15px;
        bottom: 15px;
      }

      ::slotted(*) {
        color: var(--color-white);
      }
    `],n([l()],E.prototype,"link",2),n([l()],E.prototype,"imgSrc",2),n([l()],E.prototype,"name",2),n([l({type:Boolean})],E.prototype,"blackEffect",2),n([l({type:Boolean})],E.prototype,"targetBlank",2),E=n([u("sns-button")],E);var it=class extends p{render(){return d` <div class="container"><slot></slot></div> `}};it.tagName="achievement-item",it.styles=[p.styles,m`
      .container {
        padding: var(--spacing-2_5) var(--spacing-2);
        color: var(--color-white);
        font-weight: var(--font-semibold);
        border: 1px var(--color-white) solid;
        border-radius: var(--rounded-2);
      }
    `],it=n([u("achievement-item")],it);var L=class extends p{constructor(){super(...arguments);this.title="";this.content="";this.border=!1}render(){let e=_({border:this.border});return d`<div class=${e}>
      <p class="title">${this.title}</p>
      <p class="content">${this.content}</p>
    </div>`}};L.tagName="confirm-item",L.styles=[p.styles,m`
      .title {
        font-size: var(--text-2xl);
        font-weight: var(--font-bold);
      }
      .content {
        padding: var(--spacing-7_5) 0px;
      }
      .border {
        border-bottom: 1px solid var(--color-blue-gray);
      }
    `],n([l()],L.prototype,"title",2),n([l()],L.prototype,"content",2),n([l({type:Boolean})],L.prototype,"border",2),L=n([u("confirm-item")],L);var C=class extends p{constructor(){super(...arguments);this.link="";this.target="";this.action="";this.bgSrc=""}render(){return d` <a href=${this.link}>
      <div class="container aspect-ration-img" style="--bg-src: url('${this.bgSrc}');">
        <div class="content">
          <p class="target target-sm">${this.target}</p>
          <p class="action action-sm">${this.action}</p>
        </div>
        <right-arrow class="arrow"></right-arrow>
      </div>
    </a>`}};C.tagName="content-link",C.styles=[p.styles,m`
      .container {
        display: grid;
        place-items: center;
        min-width: 160px;
        height: 100%;
        position: relative;
        z-index: 1;
        width: 100%;
      }
      @media (max-width: 639px) {
        .aspect-ration-img {
          aspect-ratio: 163 / 141;
        }
      }

      .container::after {
        content: '';
        background-image: var(--bg-src);
        background-size: cover;
        background-position: 50%;
        display: block;
        position: absolute;
        z-index: 0;
        width: 100%;
        height: 100%;
        /* filter: brightness(0.4); */
      }

      .content {
        z-index: 2;
        text-align: center;
      }
      .arrow {
        width: 25%;
        max-width: 100px;
        position: absolute;
        bottom: 20px;
        z-index: 1;
      }
      p {
        font-weight: var(--font-weight-xl);
        color: var(--color-white);
        font-weight: var(--font-bold);
      }
      .target {
        font-size: var(--text-xs);
        line-height: var(--text-xs);
        letter-spacing: var(--tracking-large);
      }
      .action {
        font-size: var(--text-headline);
        line-height: var(--text-headline);
        margin-top: var(--spacing-2_5);
        letter-spacing: var(--tracking-headline);
      }
      @media (min-width: 640px) {
        .target-sm {
          font-size: 15px;
        }
        .action-sm {
          margin-top: var(--spacing-4_5);
          font-size: 38px;
          letter-spacing: var(--tracking-headline-large);
          line-height: 34px;
        }
      }
    `],n([l()],C.prototype,"link",2),n([l()],C.prototype,"target",2),n([l()],C.prototype,"action",2),n([l()],C.prototype,"bgSrc",2),C=n([u("content-link")],C);var U=class extends p{constructor(){super(...arguments);this.role="";this.subtext="";this.review=""}render(){return d`<div class="container">
      <div class="content-container">
        <p class="role role-sm">${this.role}</p>
        <p class="subtext subtext-sm">${this.subtext}</p>
        <p class="review review-sm">${this.review}</p>
      </div>
    </div>`}};U.tagName="customer-review",U.styles=[p.styles,m`
      .container {
        background-color: var(--color-beige);
        padding: 0px var(--spacing-12);
      }
      .content-container {
        border-radius: var(--rounded-0_5);
        text-align: center;
        padding: var(--spacing-10) 0px;
      }
      .role {
        font-size: var(--text-sm);
      }
      @media (min-width: 640px) {
        .role-sm {
          font-size: var(--text-2xl);
        }
      }
      .subtext {
        color: var(--color-blue-gray-density);
        margin-top: var(--spacing-4);
        font-size: var(--text-sm);
      }
      @media (min-width: 640px) {
        .subtext-sm {
          font-size: var(--text-lg);
        }
      }
      .review {
        margin-top: var(--spacing-5);
        font-size: var(--text-md);
      }
      @media (min-width: 640px) {
        .review-sm {
          font-size: var(--text-lg);
        }
      }
    `],n([l()],U.prototype,"role",2),n([l()],U.prototype,"subtext",2),n([l()],U.prototype,"review",2),U=n([u("customer-review")],U);var q=class extends p{constructor(){super(...arguments);this.imageSrc="";this.heading=""}render(){return d`
      <div class="container md-bg-img" style="--bg-image:url(${this.imageSrc})">
        <div class="item">
          <h1>${this.heading}</h1>
        </div>
      </div>
    `}};q.tagName="image-and-heading",q.styles=[p.styles,m`
      .container {
        width: 100%;
        height: 100vh;
        height: 100dvh;
        display: grid;
        place-items: center;
        background-image: var(--bg-image);
        background-size: cover;
        background-position-x: 45%;
      }
      @media (min-width: 768px) {
        .md-bg-img {
          height: unset;
          max-height: 938px;
          object-fit: contain;
          background-position: center;
          aspect-ratio: 1926 / 938;
        }
      }
      .item {
        border: 1px solid rgba(255, 255, 255, 0.5);
        background-color: rgba(0, 0, 0, 0.4);
        padding: var(--spacing-5) var(--spacing-6) var(--spacing-2) var(--spacing-6);
        line-height: 0px;
      }
      h1 {
        color: var(--color-white);
        letter-spacing: 14px;
        font-family: var(--font-FOT-TsukuAOldMin-Pr6);
        font-weight: var(--font-normal);
        font-size: var(--text-headline-vertical);
        writing-mode: vertical-rl;
      }
    `],n([l()],q.prototype,"imageSrc",2),n([l()],q.prototype,"heading",2),q=n([u("image-and-heading")],q);var A=class extends p{constructor(){super(...arguments);this.name="";this.review="";this.iconUrl="";this.readMoreLink="";this.readMoreText=""}render(){return d`<div class="container">
      <div class="review-container">
        <div class="review review-sm">${this.review}</div>
        <div class="review-bottom">
          <p class="name">${this.name}さん</p>
          <!-- <a href=${this.readMoreLink} class="readmore-container">
            <p class="readmore">${this.readMoreText}</p>
            <right-arrow class="right-arrow" stroke="var(--color-blue-gray-density)"></right-arrow>
          </a> -->
        </div>
      </div>
      <div class="icon-container">
        <img src=${this.iconUrl} alt="user icon" width="30%" height="auto" />
      </div>
    </div>`}};A.tagName="interview-preview",A.styles=[p.styles,m`
      .container {
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
      }
      .review {
        overflow-x: hidden;
        white-space: pre-wrap;
        font-size: 12px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
      }
      .right-arrow {
        width: 20px;
      }
      @media (min-width: 640px) {
        .review-sm {
          font-size: 14px;
        }
      }
      .review-container {
        padding: var(--spacing-10) var(--spacing-8_5);
        border-radius: var(--rounded-0_5);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: var(--color-white);
      }
      .review-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: var(--spacing-7_5);
        gap: var(--spacing-2);
      }
      .readmore-container {
        flex-shrink: 0;
      }
      .readmore {
        font-size: 9px;
      }
      .icon-container {
        text-align: center;
        margin-top: var(--spacing-4_5);
      }
      .icon-container img {
        max-width: 100px;
        object-fit: contain;
        display: inline-block;
        border-radius: 9999px;
      }

      a {
        color: var(--color-blue-gray-density);
        display: flex;
        gap: var(--spacing-1);
      }
      .name {
        font-family: var(--font-A-OTF-Ryumin-Pro);
        font-weight: var(--font-semibold);
        font-size: var(--text-sm);
      }
    `],n([l()],A.prototype,"name",2),n([l()],A.prototype,"review",2),n([l()],A.prototype,"iconUrl",2),n([l()],A.prototype,"readMoreLink",2),n([l()],A.prototype,"readMoreText",2),A=n([u("interview-preview")],A);var gt=class extends H{constructor(t){if(super(t),this.it=b,t.type!==et.CHILD)throw Error(this.constructor.directiveName+"() can only be used in child bindings")}render(t){if(t===b||t==null)return this._t=void 0,this.it=t;if(t===y)return t;if(typeof t!="string")throw Error(this.constructor.directiveName+"() called with a non-string value");if(t===this.it)return this._t;this.it=t;let e=[t];return e.raw=e,this._t={_$litType$:this.constructor.resultType,strings:e,values:[]}}};gt.directiveName="unsafeHTML",gt.resultType=1;var pe=rt(gt);var X=class extends T{constructor(){super(...arguments);this.html=""}render(){return d`<div class="container">${pe(this.html)}</div>`}static register(){customElements.get(this.tagName)||customElements.define(this.tagName,this)}};X.tagName="raw-element",X.styles=[m`
      p {
        min-height: 1ch;
      }
    `],n([l()],X.prototype,"html",2),X=n([u("raw-element")],X);var Z=class extends p{constructor(){super(...arguments);this.step=1}render(){return d`<div class="container">
      <div class="top">
        <div class="step">${this.step}.</div>
        <div class="headline">
          <slot name="headline"></slot>
        </div>
      </div>
      <div class="description"><slot name="description"></slot></div>
    </div>`}};Z.tagName="step-description",Z.styles=[p.styles,m`
      .container {
        font-weight: var(--font-medium);
        padding: var(--spacing-12) var(--spacing-6) var(--spacing-20) var(--spacing-6);
        border-radius: var(--rounded-2_5);
      }
      .description {
        margin: 0px var(--spacing-3);
        padding-top: var(--spacing-7);
        border-top: 1px solid var(--color-blue-gray);
      }
      .top {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: var(--spacing-7);
      }
      .headline {
        font-size: var(--text-headline);
        font-weight: var(font-semibold);
      }
      .step {
        color: var(--color-accent);
        font-size: var(--text-headline);
        margin-right: var(--spacing-7_5);
      }
    `],n([l({type:Number})],Z.prototype,"step",2),Z=n([u("step-description")],Z);var x=class extends p{constructor(){super(...arguments);this.amount=0;this.visibleIndex=0;this.navigationText="";this.circleColor="white";this.navigationBottom="10%";this.navigationButtons=!1;this.autoscroll=!1;this.scrollIntervalRef=0;this.nextTarget=null;this.prevTarget=null}render(){let e=Et({"--circle-color":{white:"var(--color-white)",blue:"var(--color-blue)"}[this.circleColor],"--navigation-bottom":this.navigationBottom});return d`<div id="container" class="container" style=${e}>
      <div id="item-container" class="scroll-container scroll-none">
        ${Array.from({length:this.amount}).map((r,i)=>d`<div class="item" data-index="${i}"><slot id=${`item-${i}`} name=${i}></slot></div> `)}
      </div>
      <div class="navigation-container sm-bottom">
        ${this.navigationText?d`<div class="navigation-text">${this.navigationText}</div>`:void 0}
        <div class="navigation">
          ${Array.from({length:this.amount}).map((r,i)=>d`<div class=${this.visibleIndex===i?"filled-circle":"outline-circle"}></div> `)}
        </div>
        <div class="container-wrapper">
          <div class="button-container">
            <div>${this.renderPrevButton()}</div>
            <div>${this.renderNextButton()}</div>
          </div>
        </div>
      </div>
    </div>`}firstUpdated(){if(this.observer=new IntersectionObserver(e=>{e.filter(r=>r.isIntersecting).forEach(r=>{this.visibleIndex=Number(r.target.dataset.index)})},{root:this.itemContainer,rootMargin:"0px",threshold:.5}),this.shadowRoot.querySelectorAll(".item").forEach(e=>{this.observer.observe(e)}),this.autoscroll){let e=!1;this.scrollIntervalRef=0;let r=()=>{let o=()=>{if(e)return;e=!0;let a=this.getNextTarget(),h=this.getFirstTarget();a?this.itemContainer.scrollTo({left:a.offsetLeft,behavior:"smooth"}):h&&this.itemContainer.scrollTo({left:0,behavior:"smooth"})};this.scrollIntervalRef=window.setInterval(o,4e3)};r();let i=0;this.itemContainer.addEventListener("scroll",()=>{window.clearTimeout(i),i=window.setTimeout(()=>{this.itemContainer.dispatchEvent(new Event("custom-scrollend"))},100),!e&&window.clearInterval(this.scrollIntervalRef)}),this.itemContainer.addEventListener("custom-scrollend",()=>{if(e){e=!1;return}r()})}}disconnectedCallback(){window.clearInterval(this.scrollIntervalRef)}updated(e){super.update(e),this.nextTarget=this.getNextTarget(),this.prevTarget=this.getPreviousTarget()}getPreviousTarget(){return this.visibleIndex>0?this.itemContainer.children.item(this.visibleIndex-1):null}getNextTarget(){return this.itemContainer.children.item(this.visibleIndex+1)}getFirstTarget(){return this.itemContainer.children.item(0)}renderNextButton(){let e="https://cdn.shopify.com/s/files/1/0570/4479/5521/files/next-button.svg?v=1720280445";return!this.navigationButtons||!this.nextTarget?null:d`<button @click=${()=>{var i;(i=this.nextTarget)==null||i.scrollIntoView({behavior:"smooth",block:"nearest",inline:"center"})}}><img src=${e} alt="次へ進む" /></button>`}renderPrevButton(){let e="https://cdn.shopify.com/s/files/1/0570/4479/5521/files/previous-button.svg?v=1720280446";return!this.navigationButtons||!this.prevTarget?null:d`<button @click=${()=>{var i;(i=this.prevTarget)==null||i.scrollIntoView({behavior:"smooth",block:"nearest",inline:"center"})}}><img src=${e} alt="前へ戻る" /></button>`}};x.tagName="horizontal-snap-image",x.styles=[p.styles,m`
      :host {
        width: 100%;
        height: 100%;
      }
      .container {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .scroll-container {
        scroll-snap-type: x mandatory;
        overflow: auto;
        width: 100%;
        height: 100%;
        overscroll-behavior-x: auto;
        display: flex;
      }
      .item {
        scroll-snap-align: start;
        scroll-snap-stop: always;
        overflow: hidden;
        width: 100%;
        height: 100%;
        flex-shrink: 0;
        flex-grow: 0;
        display: block;
      }
      .navigation-container {
        position: absolute;
        left: 0px;
        right: 0px;
        bottom: var(--navigation-bottom);
      }
      /* @media (min-width: 640px) {
        .sm-bottom {
          bottom: 152px;
        }
      } */
      .navigation-text {
        color: var(--color-white);
        text-align: center;
        margin-bottom: var(--spacing-8);
      }
      .navigation {
        margin: 0 auto;
        width: fit-content;
        display: flex;
        gap: 8px;
      }
      .filled-circle {
        width: 10px;
        height: 10px;
        border-radius: 999px;
        background-color: var(--circle-color);
      }
      .outline-circle {
        width: 10px;
        height: 10px;
        border-radius: 999px;
        border: 1.5px solid var(--circle-color);
      }

      .container-wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
      }

      .button-container {
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: var(--max-container-width);
        padding: 0px var(--spacing-10);
      }
      button {
        border-radius: 9999px;
      }
    `],n([l({type:Number})],x.prototype,"amount",2),n([l({type:Number,attribute:!1})],x.prototype,"visibleIndex",2),n([l()],x.prototype,"navigationText",2),n([l()],x.prototype,"circleColor",2),n([l()],x.prototype,"navigationBottom",2),n([l({type:Boolean})],x.prototype,"navigationButtons",2),n([l({type:Boolean})],x.prototype,"autoscroll",2),n([S("#item-container")],x.prototype,"itemContainer",2),n([ut()],x.prototype,"nextTarget",2),n([ut()],x.prototype,"prevTarget",2),x=n([u("horizontal-snap-image")],x);var w=class extends p{constructor(){super(...arguments);this.srcs="";this.width="";this.height="";this.images=[];this.currentIndex=0;this.nextIndex=1}attributeChangedCallback(e,r,i){super.attributeChangedCallback(e,r,i),e==="srcs"&&(this.images=ze(i||""))}firstUpdated(e){this.changeImage(),window.setInterval(()=>this.changeImage(),6e3)}render(){return d`<div class="container" style=${`--width: ${this.width}px;--height: ${this.height}px;`}>
      <img id="img1" class="img" alt="" width=${this.width} height=${this.height} />
      <img id="img2" class="img" alt="" width=${this.width} height=${this.height} />
    </div>`}changeImage(){!this.img1||!this.img2||(this.img1.src=this.images[this.currentIndex],de(this.img1),he(this.img2),setTimeout(()=>{he(this.img1),this.img2.src=this.images[this.nextIndex],de(this.img2),this.currentIndex=(this.currentIndex+2)%this.images.length,this.nextIndex=(this.nextIndex+2)%this.images.length},3e3))}};w.tagName="image-switcher",w.styles=[p.styles,m`
      .container {
        position: relative;
        width: var(--width);
        height: var(--height);
      }
      .img {
        position: absolute;
        inset: 0;
        transition: opacity 1s;
      }
      .hidden {
        opacity: 0;
      }
      .visible {
        opacity: 1;
      }
    `],n([l()],w.prototype,"srcs",2),n([l()],w.prototype,"width",2),n([l()],w.prototype,"height",2),n([ut()],w.prototype,"images",2),n([S("#img1")],w.prototype,"img1",2),n([S("#img2")],w.prototype,"img2",2),w=n([u("image-switcher")],w);var ze=s=>s.split(",").map(t=>t.trim());function de(s){s.classList.add("visible"),s.classList.remove("hidden")}function he(s){s.classList.add("hidden"),s.classList.remove("visible")}function*me(s,t){let e=typeof t=="function";if(s!==void 0){let r=-1;for(let i of s)r>-1&&(yield e?t(r):t),r++,yield i}}var V=class extends p{constructor(){super(...arguments);this.pageAmount=1;this.currentPage=1}render(){let e=this.currentPage>1,r=this.pageAmount>this.currentPage;return d`<div class="container">
      ${this.renderArrow(!1,e)} ${this.renderItems()} ${this.renderArrow(!0,r)}
    </div>`}renderItems(){let e=Math.max(Math.min(this.currentPage,this.pageAmount),0),r=new Set([1,e-1,e,e+1,this.pageAmount]),i=Array.from(r.values()).filter(a=>a>0&&a<=this.pageAmount).sort((a,h)=>a-h),o=i.reduce((a,h,c)=>(c>0&&i[c-1]+1!==h&&a.push(this.renderEllipsis()),[...a,this.renderItem(h)]),[]);return d`${me(o,d``)}`}renderItem(e){let r=_({item:!0,"current-item":e===this.currentPage});return d`<a href=${this.getLink(e)}><div class=${r}>${e}</div></a>`}renderEllipsis(){return d`<div class="item thin">•••</div>`}renderArrow(e,r){let i=_({item:!0,hidden:!r,"rotate-180":e});return d` <a href=${this.getLink(e?this.currentPage+1:this.currentPage-1)}>
      <div class=${i}>
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Vector 26" d="M8.5 5L6 7.5L8.5 10" stroke="#123255" />
        </svg></div
    ></a>`}getLink(e){return`${window.location.pathname}?page=${e}`}};V.tagName="pagination-bar",V.styles=[p.styles,m`
      .container {
        display: flex;
        gap: 2px;
      }
      .item {
        display: grid;
        place-items: center;
        background-color: var(--color-white);
        line-height: 0px;
        width: 25px;
        aspect-ratio: 1 / 1;
      }
      .current-item {
        color: var(--color-white);
        background-color: var(--color-base);
      }
      .hidden {
        visibility: hidden;
      }
      .rotate-180 {
        transform: rotate(180deg);
      }
      .thin {
        font-size: var(--text-xs);
      }
    `],n([l({type:Number})],V.prototype,"pageAmount",2),n([l({type:Number})],V.prototype,"currentPage",2),V=n([u("pagination-bar")],V);var O=class extends p{constructor(){super(...arguments);this.handleChange=e=>{};this.id="";this.name=""}render(){return d` <div>
      <input class="right-arrow appearance-none" name=${this.name} type="radio" id=${this.id} />
      <label for="contact-application"><slot></slot></label>
    </div>`}};O.tagName="radio-button",O.styles=[p.styles,m`
      div {
        border: 1px solid var(--color-base);
        padding: var(--spacing-2);
        border-radius: var(--rounded-2);
        display: flex;
        text-align: left;
      }
      label {
        width: 100%;
      }
      .appearance-none {
        appearance: none;
      }

      .right-arrow {
        position: relative;
        display: inline-block;
        padding-left: 10px !important;
      }

      .right-arrow::after {
        content: '';
        width: 4px;
        height: 4px;
        border-top: 1px solid var(--color-base) !important;
        border-right: 1px solid var(--color-base) !important;
        transform: rotate(45deg);
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
      }

      .right-arrow:checked::after {
        border-top: 1px solid white !important;
        border-right: 1px solid white !important;
      }
    `],n([l()],O.prototype,"handleChange",2),n([l()],O.prototype,"id",2),n([l()],O.prototype,"name",2),O=n([u("radio-button")],O);var I=class extends p{constructor(){super(...arguments);this.amount=0}render(){return d`
      <div id="container">
        ${Array.from({length:this.amount}).map((e,r)=>d`<div class="item"><slot name=${r}></slot></div> `)}
      </div>
    `}};I.tagName="scroll-snap-image",I.styles=[p.styles,m`
      #container {
        scroll-snap-type: y mandatory;
        overflow-y: scroll;
        height: 100%;
        overscroll-behavior-y: auto;
      }
      .item {
        scroll-snap-align: start;
        scroll-snap-stop: always;
        overflow: hidden;
        width: 100%;
        height: 100%;
        flex: 1;
        flex-basis: 100%;
      }
    `],n([l({type:Number})],I.prototype,"amount",2),n([S("#container")],I.prototype,"container",2),I=n([u("scroll-snap-image")],I);var k=class extends p{constructor(){super(...arguments);this.label="";this.currentTerms="";this.searchUrl="";this.autofocus=!1}updated(e){e.has("autofocus")&&(this.autofocus?this.searchProductInput.focus():this.searchProductInput.blur())}render(){return d`
      <form action=${this.searchUrl}>
        <input type="hidden" name="type" value="product" />
        ${this.label&&d`<label for="search-product">${this.label}</label>`}
        <div class="search-box">
          <input
            id="search-product"
            type="text"
            placeholder="キーワード"
            name="q"
            value=${this.currentTerms}
            aria-label="キーワードで検索する"
            @focus=${this.onFocus}
          />
          <button type="submit" class="hover:opacity-hover active:opacity-active">検索</button>
        </div>
      </form>
    `}onFocus(){this.searchProductInput.setSelectionRange(Number.MAX_SAFE_INTEGER,Number.MAX_SAFE_INTEGER)}};k.tagName="search-form",k.styles=[p.styles,m`
      label {
        display: block;
        font-weight: var(--font-semibold);
        font-size: var(--text-2xl);
        margin-bottom: var(--spacing-3);
      }
      .search-box {
        display: flex;
        margin-bottom: var(--spacing-3);
      }
      .search-box input {
        flex: 1;
        height: var(--spacing-10);
        padding-left: var(--spacing-2);
        background-color: var(--bg-form);
      }
      .search-box button {
        margin-left: var(--spacing-2);
        padding: 0 var(--spacing-4);
        color: var(--color-white);
        background-color: var(--color-base);
      }
    `],n([l()],k.prototype,"label",2),n([l()],k.prototype,"currentTerms",2),n([l()],k.prototype,"searchUrl",2),n([S("#search-product")],k.prototype,"searchProductInput",2),n([l({type:Boolean,hasChanged(e,r){return e!==r},converter:{fromAttribute:e=>e==="true",toAttribute:e=>String(e)}})],k.prototype,"autofocus",2),k=n([u("search-form")],k);var Y=class extends p{constructor(){super(...arguments);this.stroke="black"}render(){return d` <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group 220">
        <path id="Vector 13" d="M1 0.5L31.5 31" stroke=${this.stroke} />
        <path id="Vector 14" d="M31.5 0.5L1 31" stroke=${this.stroke} />
      </g>
    </svg>`}};Y.tagName="close-icon",Y.styles=[p.styles],n([l()],Y.prototype,"stroke",2),Y=n([u("close-icon")],Y);var z=class extends p{constructor(){super(...arguments);this.stroke="white";this.height="5";this.bold=!1}render(){return this.bold?this.renderBoldArrow():this.renderNormalArrow()}renderNormalArrow(){return d` <svg
      width="100%"
      height=${this.height}
      viewBox="0 0 23 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path d="M0 4.36364H21.8636L18.4626 1" stroke-width="0.5" stroke=${this.stroke} />
    </svg>`}renderBoldArrow(){return d`
      <svg width="17" height="3" viewBox="0 0 17 3" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 2.5H15L12.6667 0.5" stroke=${this.stroke} />
      </svg>
    `}};z.tagName="right-arrow",z.styles=[p.styles,m`
      svg {
        vertical-align: super;
        display: inline;
      }
    `],n([l()],z.prototype,"stroke",2),n([l()],z.prototype,"height",2),n([l({type:Boolean})],z.prototype,"bold",2),z=n([u("right-arrow")],z);var Re="https://cdn.shopify.com/s/files/1/0570/4479/5521/files/accent-ribbon.svg?v=1716026714",Be="https://cdn.shopify.com/s/files/1/0570/4479/5521/files/blue-ribbon.svg?v=1716026714",$=class extends p{constructor(){super(...arguments);this.imgSrc="";this.name="";this.price="";this.description="";this.ranking=0;this.grayPrice=!1;this.link=""}render(){let e=_({price:!0,"text-gray":this.grayPrice});return d` <div class="container">
      <div class="ranking-ribbon-container">${this.renderRibbon()}</div>
      ${this.link?d`<a href=${this.link} class="link">
            <img class="main-image" src=${this.imgSrc} alt="" width="100%" height="auto" />
          </a>`:d`<img class="main-image" src=${this.imgSrc} alt="" width="100%" height="auto" />`}
      <div class="text-container">
        ${this.link?d`<a href=${this.link}>
              <p class="name">${this.name}</p>
            </a>`:d`<p class="name">${this.name}</p>`}
        ${this.price?d`<p class=${e}>${this.price.toLocaleString()}(税込)</p>`:""}
        ${this.description?d`<p class="description">${this.description}</p>`:""}
      </div>
    </div>`}renderRibbon(){return this.ranking<=0?null:d` <div class="ranking-ribbon">
      <span>${this.ranking}</span>
      <img src=${this.ranking===1?Re:Be} alt="" />
    </div>`}};$.tagName="product-item",$.styles=[p.styles,m`
      .link {
        display: inline-block;
      }
      .link:hover {
        opacity: 0.8;
      }
      .link:active {
        opacity: 0.6;
      }
      .container {
        background-color: var(--color-white);
        position: relative;
        border-radius: 3px;
      }
      .main-image {
        border-radius: 3px 3px 0px 0px;
        min-width: 150px;
        aspect-ratio: 1 / 1;
        object-fit: contain;
      }
      .name {
        -webkit-line-clamp: 2;
        min-height: 32px;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        font-size: 15px;
        line-height: 18px;
        font-weight: var(--font-semibold);
      }
      @media (max-width: 639px) {
        .name {
          -webkit-line-clamp: 1;
          min-height: 16px;
          font-size: 11px;
        }
      }
      .price {
        text-align: right;
        font-size: var(--text-sm);
      }
      .description {
        margin-top: var(--spacing-4);
        font-size: var(--text-xs);
        line-height: 16px;
      }
      .text-container {
        padding: var(--spacing-4) var(--spacing-2_5);
      }
      .ranking-ribbon-container {
        position: absolute;
        left: var(--spacing-2_5);
        width: 30px;
        height: 30px;
        overflow: hidden;
      }
      .ranking-ribbon {
        position: relative;
        text-align: center;
      }
      .ranking-ribbon > img {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 0;
      }
      .ranking-ribbon > span {
        position: relative;
        color: var(--color-white);
        width: 1ch;
        z-index: 1;
      }
      .text-gray {
        color: var(--color-blue-gray);
      }
    `],n([l()],$.prototype,"imgSrc",2),n([l()],$.prototype,"name",2),n([l()],$.prototype,"price",2),n([l()],$.prototype,"description",2),n([l({type:Number})],$.prototype,"ranking",2),n([l({type:Boolean})],$.prototype,"grayPrice",2),n([l()],$.prototype,"link",2),$=n([u("product-item")],$);var D=class extends p{constructor(){super(...arguments);this.heading="";this.english=""}render(){return d`
      <h2><slot name="heading"></slot></h2>
      <p><slot name="english"></slot></p>
    `}};D.tagName="heading-with-english",D.styles=[p.styles,m`
      h2 {
        font-size: var(--text-headline);
        font-weight: var(--font-bold);
        letter-spacing: 3.3px;
      }
      p {
        font-size: var(--text-lg);
        color: var(--color-blue-gray);
        margin-top: var(--spacing-3);
      }
    `],n([l()],D.prototype,"heading",2),n([l()],D.prototype,"english",2),D=n([u("heading-with-english")],D);var st=class extends p{render(){return d`<h2 class="sm"><slot></slot></h2>`}};st.tagName="headline-text",st.styles=[p.styles,m`
      h2 {
        font-size: var(--text-headline);
        font-weight: var(--font-semibold);
        font-family: var(--font-FOT-TsukuAOldMin-Pr6-D);
        letter-spacing: var(--tracking-headline);
      }
      @media (min-width: 640px) {
        .sm {
          font-size: var(--text-headline-xl);
        }
      }
    `],st=n([u("headline-text")],st);var ge=["bg-blue","text-white"];function je(...s){let t=s.map(i=>document.getElementById(i));if(!t[0])return;let e=()=>{t.forEach(i=>{var o;(o=i.parentElement)==null||o.classList.remove(...ge),Ve(i)})},r=qe();ue(t.filter(i=>i.id===r)[0]||t[0],!1),s.forEach(i=>{let o=document.getElementById(i);o&&o.addEventListener("change",function(){e(),o.checked&&ue(o,!0)})})}var He=s=>{let t=new URL(window.location.href);t.searchParams.set("type",s),window.history.replaceState("","",t.toString())},qe=()=>new URLSearchParams(window.location.search).get("type"),ue=(s,t)=>{var e,r;(e=s.parentElement)==null||e.classList.add(...ge),(r=document.getElementById(`${s.id}-container`))==null||r.classList.remove("hidden"),s.checked=!0,t&&He(s.id)},Ve=s=>{var t;(t=document.getElementById(`${s.id}-container`))==null||t.classList.add("hidden")};window.registerRadioChangeCallback=je;function Ie(s){let t=document.getElementById(s);t==null||t.addEventListener("keydown",e=>{e.key==="Enter"&&(e.preventDefault(),e.stopPropagation(),t.click())})}window.enterToClick=Ie;function De(s){let t=typeof s=="string"?document.getElementById(s):s;if(!t)throw new Error("no target");let e=t.querySelectorAll("input, textarea"),r=new Map,i=[];for(let o of Array.from(e)){let a=o.name.match(/^contact\[(.+)\]$/),h=a==null?void 0:a[1];if(!h)continue;i.push(o);let c={label:h,value:o.value,required:o.required};if(o.type==="radio"){if(o.checked){r.set(h,c);continue}r.set(h,r.get(h)||{label:h,value:"",required:o.required});continue}r.set(h,c)}return{inputs:i,values:Array.from(r.values())}}window.getAllContactInputs=De;})();
